// extracted by mini-css-extract-plugin
export default {"moon":"IconMoon_moon__Bs+-a","dark":"IconMoon_dark__4bJ8V","light":"IconMoon_light__UaYL6"};